module.exports = __webpack_public_path__ + "static/AngelaHe13-228c5170a6bb5cd38d5fe5ff07095289.webp";